import { useState } from "react";
import { toast } from "sonner";
import { CalendarClock, Trash2, Send } from "lucide-react";
import { http, errMsg } from "../../lib/api";

const KINDS = [["carousel", "Carousel post"], ["stories", "Stories"], ["reel", "Reel"]];
const STATUS = { scheduled: "text-[#9A7B2C]", sending: "text-blue-600", sent: "text-emerald-700", failed: "text-red-600" };
const sel = "rounded-sm border border-stone-300 bg-white px-2 py-1.5 text-sm";

export const SchedulePosts = ({ kit, reload }) => {
  const [f, setF] = useState({ date: "", time: "09:00", kind: "carousel" });
  const items = [...(kit.post_schedule || [])].sort((a, b) => a.due_at.localeCompare(b.due_at));
  const add = async () => {
    if (!f.date) return toast.error("Pick a date");
    try { await http.post(`/kits/${kit.id}/schedule`, f); toast.success(`Reminder set for ${f.date} ${f.time} (Sydney)`); setF({ ...f, date: "" }); reload(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const del = (id) => http.delete(`/kits/${kit.id}/schedule/${id}`).then(reload).catch((e) => toast.error(errMsg(e)));
  const now = (id) => http.post(`/kits/${kit.id}/schedule/${id}/send-now`).then(() => toast.success("Reminder emailed with files attached")).catch((e) => toast.error(errMsg(e)));
  return (
    <div data-testid="schedule-posts" className="mt-6 border-t border-stone-100 pt-5">
      <div className="eyebrow flex items-center gap-2"><CalendarClock size={13} /> Post schedule · Sydney time</div>
      <p className="text-xs text-stone-500 mt-2">At the time you choose, you'll get an email with the slides, story frames or reel attached and the caption ready to paste.</p>
      {items.length > 0 && <ul className="mt-3 divide-y divide-stone-100 text-sm">
        {items.map((i) => (
          <li key={i.id} data-testid={`schedule-item-${i.id}`} className="flex items-center gap-3 py-2">
            <span className="w-36">{i.local}</span><span className="w-32 text-stone-600">{KINDS.find((k) => k[0] === i.kind)?.[1]}</span>
            <span className={`text-xs capitalize ${STATUS[i.status]}`}>{i.status}{i.error ? ` — ${i.error}` : ""}</span>
            <button data-testid={`schedule-send-${i.id}`} onClick={() => now(i.id)} title="Email this reminder now" className="ml-auto text-stone-400 hover:text-stone-800"><Send size={14} /></button>
            <button data-testid={`schedule-delete-${i.id}`} onClick={() => del(i.id)} className="text-stone-400 hover:text-red-600"><Trash2 size={14} /></button>
          </li>
        ))}
      </ul>}
      <div className="flex flex-wrap gap-2 mt-3">
        <input data-testid="schedule-date" type="date" className={sel} value={f.date} min={new Date().toISOString().slice(0, 10)} onChange={(e) => setF({ ...f, date: e.target.value })} />
        <select data-testid="schedule-time" className={sel} value={f.time} onChange={(e) => setF({ ...f, time: e.target.value })}>
          {Array.from({ length: 18 }, (_, i) => `${String(i + 6).padStart(2, "0")}:00`).map((t) => <option key={t}>{t}</option>)}</select>
        <select data-testid="schedule-kind" className={sel} value={f.kind} onChange={(e) => setF({ ...f, kind: e.target.value })}>
          {KINDS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
        <button data-testid="schedule-add" onClick={add} className="rounded-sm bg-[#2B2A26] px-4 py-1.5 text-sm font-bold text-white">Schedule</button>
      </div>

    </div>
  );
};
